import React from 'react';
import {termsConditions, privacyPolicy} from './config';
import {
  termsConditions as termsConditionsBN,
  privacyPolicy as privacyPolicyBN,
} from './config-bn_BD';
const close = require('@components/assets/icons/close.webp');
import './index.css';
import {Trans, useTranslation} from 'react-i18next';
import ReactDOM from 'react-dom';

const Privacy = ({fix = false}: {fix?: boolean}) => {
  const [openTerms, setOpenTerms] = React.useState(false);
  const [openPrivacy, setOpenPrivacy] = React.useState(false);
  const {t} = useTranslation();
  const openTermsHandler = () => {
    setOpenTerms(true);
  };
  const closeTermsHandler = () => {
    setOpenTerms(false);
  };
  const openPrivacyHandler = () => {
    setOpenPrivacy(true);
  };
  const closePrivacyHandler = () => {
    setOpenPrivacy(false);
  };

  const {i18n} = useTranslation();
  const isBN = i18n.language === 'bn_BD';
  const _termsConditions = isBN ? termsConditionsBN : termsConditions;
  const _privacyPolicy = isBN ? privacyPolicyBN : privacyPolicy;

  return (
    <>
      <div className="text-xs text-t3">
        <Trans
          i18nKey="privacy.confirmation"
          components={{
            terms: (
              <span onClick={openTermsHandler} className="text-c1 underline">
                {t('privacy.terms')}
              </span>
            ),
            policy: (
              <span onClick={openPrivacyHandler} className="text-c1 underline">
                {t('privacy.policy')}
              </span>
            ),
          }}
        />
      </div>
      {openTerms &&
        ReactDOM.createPortal(
          <div
            className={`jump-wrap terms-conditions ${fix ? 'fix-wrap' : ''}`}>
            <img
              src={close}
              alt="close"
              onClick={closeTermsHandler}
              className="close-icon"
            />
            <h2 className="privacy-title">{t('privacy.terms')}</h2>
            <main className="terms-conditions-main">
              {_termsConditions.map((item, index) => (
                <section key={item.title || index + 1}>
                  {!!item.title && <h4>{item.title}</h4>}
                  {!!item.ul && (
                    <div>
                      {item.ul.map((tItem, tIndex) => (
                        <div key={tIndex}>
                          <div className="ul-list">
                            <span className="ul-round" />
                            <p className="ul-content">
                              <span className="ul-mark">{tItem.mark}</span>
                              <span>{tItem.content}</span>
                            </p>
                          </div>
                          {!!tItem.cul && (
                            <div className="cul-wrap">
                              {tItem.cul.map((culItem, culIndex) => (
                                <p className="ul-list" key={culIndex}>
                                  <span className="ul-round" />
                                  <span className="ul-content">{culItem}</span>
                                </p>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                  {!!item.content && (
                    <p className="terms-conditions-content">{item.content}</p>
                  )}
                  {!!item.list && (
                    <>
                      {item.list.map((lItem, lIndex) => (
                        <div key={lIndex}>
                          <p>
                            <span className="list-mark">{lItem.mark}</span>
                            <span>{lItem.content}</span>
                          </p>
                          {!!lItem.list && (
                            <div className="list-indent">
                              {lItem.list.map((li, liIndex) => (
                                <p key={liIndex}>{li}</p>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </>
                  )}
                </section>
              ))}
            </main>
          </div>,
          document.body,
        )}
      {openPrivacy &&
        ReactDOM.createPortal(
          <div
            className={`jump-wrap terms-conditions ${fix ? 'fix-wrap' : ''}`}>
            <img
              src={close}
              alt="close"
              onClick={closePrivacyHandler}
              className="close-icon"
            />
            <h2 className="privacy-title">{t('privacy.policy')}</h2>
            <main className="terms-conditions-main">
              {_privacyPolicy.map(item => (
                <section key={item.title}>
                  <h4>{item.title}</h4>
                  {!!item.content && (
                    <p className="terms-conditions-content">{item.content}</p>
                  )}
                  {!!item.list && (
                    <>
                      {item.list.map((lItem, lIndex) => (
                        <div className="terms-conditions-list" key={lIndex}>
                          {!isBN && (
                            <span className="terms-conditions-list-order">
                              {lIndex + 1}
                            </span>
                          )}
                          {`. ${lItem}`}
                        </div>
                      ))}
                    </>
                  )}
                </section>
              ))}
            </main>
          </div>,
          document.body,
        )}
    </>
  );
};

export default Privacy;
